import React from 'react';

import Component from "./Component";
import Details from "./Details";

export default ({ data, notifications, activityURL, onAssetSelected, onAssetHovered, envopsMode }) => {
  const [ selectedAsset, setSelectedAsset ] = React.useState(null);
  const [ hoveredAsset, setHoveredAsset ] = React.useState(null);

  const onHoverAsset = (asset) => {
    setHoveredAsset((oldHoveredAsset) => {
      if (asset === oldHoveredAsset) {
        return oldHoveredAsset
      }
      onAssetHovered(asset, oldHoveredAsset)
      return asset
    })
  }

  const onSelectAsset = (asset) => {
    onHoverAsset(null)
    // Use the callback version of setState as we call `onSelectAsset` from a
    // `useEffect` callback.
    setSelectedAsset((selectedAsset) => {
      // The data retrieved from FC doesn't contain chassis, they are instead
      // simulated here. That prevents an object equality check from detecting
      // if `asset` is the `selectedAsset` when it is a chassis.
      const isSelected = asset === selectedAsset ||
        (asset && selectedAsset && asset.type === "Chassis" && selectedAsset.type === "Chassis" && asset.id === selectedAsset.id)
      if (isSelected) {
        onAssetSelected(null, selectedAsset)
        return null
      } else {
        onAssetSelected(asset, selectedAsset)
        return asset
      }
    })
  }

  React.useEffect(() => {
    function assetFromTypeAndId({type, id}, data) {
      let foundAssets = []

      if (type === "asset") {
        for (const asset of data.assets || []) {
          if (`asset-${asset.id}` === id.toString()) {
            return asset
          }
        }
      }
      if (type === "chassis") {
        for (const asset of data.assets || []) {
          if (asset.chassisId != null && `chassis-${asset.chassisId}` === id.toString()) {
            foundAssets.push(asset)
          }
        }
      }
      if (data.components) {
        for (const component of data.components) {
          const assets = assetFromTypeAndId({type, id}, component)
          if (Array.isArray(assets)) {
            foundAssets = foundAssets.concat(assets)
          } else if (assets) {
            return assets
          }
        }
      }
      if (data.assetGroups) {
        for (const assetGroup of data.assetGroups) {
          if (type === "assetGroup" && assetGroup.id.toString() === id.toString()) {
            return assetGroup
          }
          const assets = assetFromTypeAndId({type, id}, assetGroup)
          if (Array.isArray(assets)) {
            foundAssets = foundAssets.concat(assets)
          } else if (assets) {
            return assets
          }
        }
      }
      if (data.groups) {
        for (const group of data.groups) {
          if (type === "assetGroup" && group.id.toString() === id.toString()) {
            return group
          }
          const assets = assetFromTypeAndId({type, id}, group)
          if (Array.isArray(assets)) {
            foundAssets = foundAssets.concat(assets)
          } else if (assets) {
            return assets
          }
        }
      }
      return foundAssets
    }

    function assetSelected(event) {
      let asset = assetFromTypeAndId(event.detail, data);
      if (Array.isArray(asset)) {
        const chassis = {
          id: event.detail.id,
          name: event.detail.name,
          icon: "fa-server",
          type: "Chassis",
          assets: asset,
          typeParam: "asset",
        }
        asset = chassis
      }
      onSelectAsset(asset);
    }

    function assetHovered(event) {
      const asset = assetFromTypeAndId(event.detail, data);
      setHoveredAsset(Array.isArray(asset) ? null : asset);
    }

    function assetUnhovered() {
      setHoveredAsset(null);
    }

    window.addEventListener("vdc:assetSelected", assetSelected)
    window.addEventListener("vdc:hoverChanged", assetHovered)
    window.addEventListener("vdc:hoverCleared", assetUnhovered)
    return () => {
      window.removeEventListener("vdc:assetSelected", assetSelected)
      window.removeEventListener("vdc:hoverChanged", assetHovered)
      window.removeEventListener("vdc:hoverCleared", assetUnhovered)
    }
  }, [])

  return (
    <>
      {selectedAsset ? (
        <Details
          componentId={data.id}
          asset={selectedAsset}
          onSelectAsset={onSelectAsset}
          onHoverAsset={selectedAsset.pseudo ? null : onHoverAsset}
          notifications={notifications}
          activityURL={activityURL}
          envopsMode={envopsMode}
          hoveredAsset={hoveredAsset}
        />
      ) : (
        <div className="mt-2">
          <Component
            component={data}
            selectedAsset={selectedAsset}
            hoveredAsset={hoveredAsset}
            onSelectAsset={onSelectAsset}
            onHoverAsset={onHoverAsset}
          />
        </div>
      )}
    </>
  );
};
